module.exports = "/_next/static/images/3b7b54fa4ca1f5c9e3ca076919348ba6-iPhone12pro_3.png.webp";